import {Tooltip2} from '@api'
import {Tooltip} from '@material-ui/core'
import {useGroupByGroupStore} from '@modules/catalog'
import {_, React, observer} from '@api'
import * as css from './GroupTitle.css'
import classNames from 'classnames'

export const GroupTitle = observer<{}, HTMLDivElement>(function GroupTitle(props, ref) {
  const {strings, props: {info, level}, isCard, totalCount, grouping: {fieldDefinition, toggleSortField, subtitleFields}, hasToolbarPopover} = useGroupByGroupStore()

  const title = fieldDefinition?.group?.custom?.formatTitle ? fieldDefinition?.group?.custom?.formatTitle(info.title) : info.title

  // toggleSortField('_key')}>
  return <div className={css.root}
              ref={ref}
    // data-showing-aggregate-details-in-sidebar={showingAggregateDetailsinSidebar}
              data-has-subtitle-fields={!_.isEmpty(subtitleFields)}
              data-type='GroupTitle'
              data-level={level}
    // onClick={toggleSortField('_key')}
  >

    <Tooltip2 content={hasToolbarPopover ? '' : (`${title}\n(Click to Sort)` || '')} placement='bottom'>
      <span data-level={level}
            data-type='GroupTitle'
            className={classNames(css.titleText, {[css.levelZero]: level === 0, [css.levelOne]: level === 1})}>
        {title === '' || title === null || title === undefined ? strings.noValue : _.trim(title)}{false && isCard && totalCount ? `  (${totalCount.toLocaleString()})` : null}
      </span>
    </Tooltip2>
    {/*{false && orderBy.field == '_key' && <Icon icon={orderBy.order == 'asc' ? 'caret-up' : 'caret-down'}/>}*/}
  </div>
}, {forwardRef: true})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupTitle.tsx